<template>
  <div class="container">
    <div class="left" @click="showMenu">
      <userMenu :headImg="require('../../public/images/user.jpg')" :currentType="1" :showFlag="menuFlag"></userMenu>
    </div>
    <div class="right">
      <h5>我的预约</h5>
      <section class="myorder">
        <p>您已预约：</p>
        <p class="noList" v-if="list.length==0">
          当前未预约
        </p>
        <div v-else>
          <div class="row" v-for="item in list">
            <div>{{item.date}} {{item.week}}</div>
            <div class="btn btn-default">{{item.time}}</div>
            <div>{{item.type_name}}</div>
            <div :class="item.status=='未使用'?'btn btn-primary':'btn btn-default'">{{item.status}}</div>
          </div>
        </div>
        <page-component :total="totalPage" :current="currentPage" @getPage="catchPage"></page-component>
      </section>
    </div>
  </div>
</template>

<script>
import userMenu from '../components/user.vue'
import pageComponent from '../components/pagination.vue'
export default {
  inject: ['ajax'],
  props: {

  },
  data() {
    return {
      list: [],
      totalPage: 0,
      currentPage: 1,
      menuFlag: false
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.ajax(`/api/reserve/my?page=1`, 'get', '', res => {
      this.list = res.data.data
      this.totalPage = res.data.count
    })
  },
  watch: {

  },
  methods: {
    showMenu() {
      this.menuFlag = !this.menuFlag
    },
    catchPage(page) {
      this.currentPage = page
      if (page != this.$route.query.page) {
        window.location.href = `/myorder?page=${page}`
      }
    }
  },
  components: {
    userMenu,
    pageComponent
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.left {
  width: 200px;
}

.myorder {
  padding: 30px 3px;
}

.myorder > p {
  color: #333;
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 16px;
}

.myorder .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  padding: 10px 2.3em;
  color: #333;
  font-size: 1em;
  margin-bottom: 16px;
}

.myorder .btn {
  margin: 0;
}

.noList {
  font-size: 0.9em !important;
  color: #999 !important;
  text-align: center;
  font-weight: normal;
}
@media only screen and (max-width: 750px) {
  .right > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .myorder > p {
    font-size: 0.14rem;
  }
  .right {
    padding: 0.1rem;
  }
  .myorder .row {
    padding: 0.1rem 0.05rem;
    font-size: 0.12rem;
  }
  .btn {
    width: 0.6rem;
  }
}
</style>